"use client";

import { useAuth } from "@/graphql/auth";
import { UserContextProvider } from "@/services/contexts/UserContext";

export default function UserProviderClient({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return null;

  return (
    <UserContextProvider initialUser={user}>
      {children}
    </UserContextProvider>
  );
}
